import gql from "graphql-tag";

const TAG_TRACKING_UPDATE_ACTIVE = gql`
  mutation updateOrgEventsTarget($id: ID, $active: Boolean) {
    updateEventsTarget(where: { id: $id }, data: { isActive: $active }) {
      id
      name
      isActive
    }
  }
`;

export default TAG_TRACKING_UPDATE_ACTIVE;
